import React from "react";
import { PRIVACY_REQUEST_EMAIL } from "../../core/constants";
import { useI18n } from "../../features/i18n/LocaleProvider";
import PolicyPage from "./PolicyPage";

export default function PrivacyPage({ acc }) {
  const { t } = useI18n();
  const sections = [
    { heading: t("privacy_h1"), body: t("privacy_b1") },
    { heading: t("privacy_h2"), body: t("privacy_b2") },
    { heading: t("privacy_h3"), body: t("privacy_b3") },
    { heading: t("privacy_h4"), body: t("privacy_b4") },
    { heading: t("privacy_h5"), body: t("privacy_b5") },
    { heading: t("privacy_h6"), body: t("privacy_b6") },
    { heading: t("privacy_h7"), body: `${t("privacy_b7")}: ${PRIVACY_REQUEST_EMAIL}` },
  ];

  return <PolicyPage title={t("privacy_policy")} updatedAt={t("policy_updated_at")} sections={sections} acc={acc} />;
}
